import "./Copyright.scss";

const Copyright = ({classesName}) => {
  const date = new Date().getFullYear();
  return (
    <p className={`copyright ${classesName? classesName: ""}`}>
      Copyright ©{date} All rights reserved
    </p>
  );
};


export default Copyright;